import { LoaderCircleIcon, ShieldCheckIcon } from 'lucide-react';
import { EntryHeading } from './entry-shell';
import { namespaceCopyFor } from '@/i18n/ns';
import entrySurfaceCopy from '@/i18n/ns/entry-surfaces';

export function GoogleSignInPending({ locale }: { locale: string }) {
  const copy = namespaceCopyFor(entrySurfaceCopy, locale);
  return (
    <section className="pc-google-pending" aria-live="polite" aria-busy="true">
      <div className="pc-google-pending-icon" aria-hidden="true">
        <ShieldCheckIcon />
      </div>
      <EntryHeading title={copy.googlePendingTitle} lead={copy.googlePendingLead} />
      <div className="pc-google-pending-status" role="status">
        <LoaderCircleIcon aria-hidden="true" />
        <span>{copy.googlePendingWaiting}</span>
      </div>
      <p className="pc-google-pending-note">{copy.googlePendingNote}</p>
    </section>
  );
}
